import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormValueService {
  private form ?: FormGroup;

  constructor() { }

  private codigoPostalSubject = new Subject<any>();
  private rfcSubject = new Subject<any>();
  private limitSubject = new Subject<any>();
  private fieldOptionsSubject = new Subject<any>();

  codigoPostal$: Observable<any> = this.codigoPostalSubject.asObservable();
  rfc$: Observable<any> = this.rfcSubject.asObservable();
  limit$: Observable<any> = this.limitSubject.asObservable();
  fieldOptions$: Observable<any> = this.fieldOptionsSubject.asObservable();

  public setForm(form: FormGroup): void {
    this.form = form;
  }

  public emitPostalCode(value: any) {
    this.codigoPostalSubject.next(value);
  }
  public emitRFC(value: any) {
    this.rfcSubject.next(value);
  }
  public emitLimit(value: any) {
    this.limitSubject.next(value);
  }

  // Hace el patchValue al dynamicInput
  //PARAMETROS:
  // fieldName: Nombre del campo del formulario
  // value: valor que se actualizara
  public updateDynamicInput(fieldName : string, value: string): void {
    const fieldControl =  this.form?.get(fieldName);
    if (fieldControl) {
      fieldControl?.patchValue(value);
    }
  }

  // Actualiza las opciones del DynamicSelect
  //PARAMETROS:
  // fieldName: Nombre del campo del formulario
  // options: Arrreglo que contiene las nuevas opciones
  public setOptionsDynamicSelect(fieldName: string, options: any[]) {
    this.fieldOptionsSubject.next({ fieldName, options });
  }
  
  // Selecciona una opción del dynamicSelect
  //PARAMETROS:
  // fieldName: Nombre del campo del formulario
  // optionValue: opcion que se seleccionara
  public pickOptionDynamicSelect(fieldName : string, optionValue: any): void {
    const fieldControl =  this.form?.get(fieldName);
    if (fieldControl) {
      fieldControl?.patchValue(optionValue);
    }
  }

}
